// Edit your dedicated offerings here.
// Keep "monthly" as the anchor price; discounts apply for 3/6/12 month prepay.

export const DEDICATED_DISCOUNTS = [
  { id: "m", months: 1, discount: 0.0, label: "Monthly", sublabel: "No discount" },
  { id: "q", months: 3, discount: 0.05, label: "3 months", sublabel: "Save 5%" },
  { id: "h", months: 6, discount: 0.10, label: "6 months", sublabel: "Most popular • Save 10%" },
  { id: "y", months: 12, discount: 0.20, label: "12 months", sublabel: "Best value • Save 20%" },
];

// Offerings — change these anytime
export const DEDICATED_OFFERINGS = [
  {
    id: "xeon-entry",
    name: "Dedicated — Entry",
    badge: "Best starter",
    monthly: 89,
    locations: ["UK", "DE"],
    specs: {
      cpu: "Intel Xeon (8c/16t)",
      ram: "64GB DDR4",
      storage: "2x1TB NVMe",
      bandwidth: "1Gbps",
      ddos: "Included",
    },
    idealFor: ["Small networks", "Web + bots", "Game communities"],
  },
  {
    id: "ryzen-performance",
    name: "Dedicated — Performance",
    badge: "Most popular",
    monthly: 139,
    locations: ["UK", "DE", "NL"],
    specs: {
      cpu: "Ryzen 9 (12c/24t)",
      ram: "128GB DDR5",
      storage: "2x2TB NVMe",
      bandwidth: "1Gbps",
      ddos: "Included",
    },
    idealFor: ["Large communities", "Multiple services", "Heavy modpacks"],
  },
  {
    id: "beast",
    name: "Dedicated — Beast",
    badge: "Best value",
    monthly: 199,
    locations: ["DE"],
    specs: {
      cpu: "Ryzen 9 / High-end",
      ram: "256GB DDR5",
      storage: "2x2TB NVMe",
      bandwidth: "10Gbps",
      ddos: "Included",
    },
    idealFor: ["Serious infra", "Many instances", "High traffic workloads"],
  },
];
